// Frittstående Dispatch-kø-panel (poppet ut til egen skjerm), DISP-01.
// Samme mønster som `panels/rfi-panel.ts`: egen WS-feed (cookie-auth); RFI-er
// (inkl. klaim/frigjøring) flyter via hubbens collab-fanout (org-scope) og
// flettes monotont.
import { parseRfiOne, mergeRfi, type Rfi } from '@skade/contracts';
import type { User } from '@skade/rbac';
import type { Feed } from '../data/feed.js';
import type { SyncBus } from '../sync.js';
import { DispatchPanel } from '../ui/dispatch.js';

export function mountDispatchPanel(root: HTMLElement, feed: Feed, _sync: SyncBus, user: User): void {
  document.body.classList.add('panel-standalone');
  root.innerHTML = '';
  const rfis = new Map<string, Rfi>();
  const upsert = (r: Rfi) => {
    const e = rfis.get(r.id); rfis.set(r.id, e ? mergeRfi(e, r) : r);
    if (rfis.size > 500) { const o = [...rfis.values()].sort((a, b) => a.createdMs - b.createdMs)[0]; if (o) rfis.delete(o.id); }
  };
  const panel = new DispatchPanel({
    self: user.id,
    getRfis: () => [...rfis.values()],
    publish: (r) => { upsert(r); feed.send?.({ type: 'rfi', rfi: r }); },
    naa: () => Date.now(),
  });
  panel.el.classList.add('open', 'embedded');
  root.append(panel.el);
  feed.onCollab?.((m) => { if (m.kind === 'rfi' && m.rfi) { const r = parseRfiOne(m.rfi); if (r) { upsert(r); panel.render(); } } });
  feed.start();
}
